/**
 * Created by Pradeep Kumar on 6/25/2019.
 */

import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class TombOfNefertitiReelPartAnimator extends SpinReelPartAnimator {

    private powerEaseIn(t:number, d:number, pow:number) {
        return Math.pow(t / d, pow);
    }

    public setupTweenSpinSpeedQueue(endSpeed:number, steps:number):void {
        this._spinSpeedsQueue = [];

        for(let i:number = 0; i < steps; i++) {
            this._spinSpeedsQueue.push(this.spinSpeed + (endSpeed - this.spinSpeed) * this.powerEaseIn(i, steps - 1, 3));
        }
        this.spinSpeed = this._spinSpeedsQueue[this._spinSpeedsQueue.length - 1];
    }

    public getStopTime(stopSteps:number, nearWin:boolean): number {
        if (this.isQuickStop) {
            this.spinSpeed = TombOfNefertitiGameConfig.instance.REEL_SPIN_SPIN_SPEED;
        }
        return super.getStopTime(stopSteps, nearWin);
    }
}